import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { setAccessToken } from "../api/api";

export default function OAuthSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const getCalendarConnectErrorMessage = (rawMessage) => {
    const text = String(rawMessage || "").toLowerCase();

    if (!text) return "Could not connect calendar. Please try again.";
    if (text.includes("already linked to another user")) {
      return "This calendar account is already connected to another profile. Please use a different account.";
    }
    if (text.includes("missing code or state")) {
      return "Connection could not be completed. Please try again.";
    }
    if (text.includes("failed to exchange code")) {
      return "Connection failed at provider step. Please try again.";
    }
    if (text.includes("no access token returned")) {
      return "Connection did not complete. Please try again.";
    }
    if (text.includes("temporarily unavailable")) {
      return "Connection service is busy right now. Please try again shortly.";
    }
    if (text.includes("oauth error")) {
      return "Calendar connection was cancelled or failed. Please try again.";
    }
    return "Could not connect calendar. Please try again.";
  };

  useEffect(() => {
    const token = params.get("token");
    const flow = params.get("flow");
    const provider = params.get("provider");
    const status = params.get("status");
    const message = params.get("message");
    const existingToken = localStorage.getItem("token");

    if (flow === "calendar" && status === "failed") {
      toast.error(getCalendarConnectErrorMessage(message));
      if (existingToken) {
        setAccessToken(existingToken);
        navigate("/calendar-setup", { replace: true });
      } else {
        navigate("/login", { replace: true });
      }
      return;
    }

    if (token) {
      const hadToken = !!existingToken;
      setAccessToken(token);
      localStorage.setItem("token", token);

      if (flow === "calendar") {
        const label = provider === "microsoft" ? "Microsoft" : "Google";
        toast.success(`${label} calendar connected successfully`);
      } else if (!hadToken) {
        toast.success("Login successful");
      }

      navigate("/calendar-setup", { replace: true });
    } else {
      const existingToken = localStorage.getItem("token");
      if (existingToken) {
        setAccessToken(existingToken);
        navigate("/calendar-setup", { replace: true });
      } else {
        toast.error("OAuth login failed");
        navigate("/login", { replace: true });
      }
    }
  }, [params, navigate]);

  return <p className="text-center mt-5">Signing you in...</p>;
}
